import { AnyAction, IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { LayersPropertiesState } from "../layerProperties.reducer";

export const storeGisServerUrlPartialReducer: IPartialReducer<LayersPropertiesState> = (
    state: LayersPropertiesState,
    action: AnyAction
) => {
    return {
        gisServerUrl: action.url,
    };
};
